<template>
    <div>
        <!-- ACTION BAR -->
        <div class="container-action-bar">
            <CompassTooltip :arrow="false">
                <template #content>
                    <span>{{ pinStatusLabel }}</span>
                </template>
                <span>
                    <CompassIconButton
                        icon="pin"
                        size="small"
                        :active="isPinned"
                        @click="onClickPin"
                    />
                </span>
            </CompassTooltip>
            <!-- Custom tooltip for 'more actions' -->
            <div ref="customTooltip" :class="customTooltipClasses">
                {{ labels.moreActionsTooltip }}
            </div>
            <span v-if="oneLog.can_edit || oneLog.can_delete">
                <CompassMenu
                    ref="actionBarMenu"
                    size="small"
                    placement="top-end"
                    customClass="container-action-bar__menu"
                    :disabled="!isActionBarVisible"
                >
                    <CompassIconButton
                        icon="action"
                        size="small"
                        @click="handleCustomTooltipVisibility"
                        @mouseenter="handleCustomTooltipVisibility"
                        @mouseleave="handleCustomTooltipVisibility"
                    />
                    <template #dropdown>
                        <CompassDropdownOption
                            v-if="canEdit"
                            :label="labels.menuItemModify"
                            @itemSelected="editElement(oneLog)"
                        />
                        <CompassDropdownOption
                            v-if="canDelete"
                            :label="labels.menuItemDelete"
                            @itemSelected="deleteModal = true"
                        />
                    </template>
                </CompassMenu>
            </span>
        </div>
        <!-- POPUP -->
        <CompassModal
            v-model:visible="deleteModal"
            size="small"
            :title="$t.__('common.actions.delete_message')"
            @closed="$emit('close')"
        >
            <template #default>
                <div class="dialog__default">
                    <p class="typographies-paragraph-medium-regular">
                        {{
                            $l10n.__('Confirmez-vous vouloir faire disparaître votre commentaire ?')
                        }}
                    </p>
                    <ul>
                        <li class="typographies-paragraph-medium-regular">
                            -
                            {{ $l10n.__('Il n’apparaitra plus pour aucun de vos collaborateurs.') }}
                        </li>
                        <li class="typographies-paragraph-medium-regular">
                            - {{ $l10n.__('Ceci est une action définitive.') }}
                        </li>
                    </ul>
                </div>
            </template>
            <template #footer>
                <div class="dialog__footer">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        :disabled="isDeletePending"
                        @click="deleteModal = false"
                    />
                    <CompassButton
                        :label="$t.__('common.actions.delete')"
                        type="primary-destructive"
                        :loading="isDeletePending"
                        class="ml-3"
                        @click="deleteElement(oneLog)"
                    />
                </div>
            </template>
        </CompassModal>
    </div>
</template>
<script>
import TimelineActionBar from 'vcomponents/timeline/timelineActionBar/TimelineActionBar.vue';
import AnnotationService from 'Services/Annotations/AnnotationService';

export default {
    name: 'TimelineActionBarAnnotation',
    extends: TimelineActionBar,
    data() {
        return {
            annotationService: new AnnotationService(),
            deleteModal: false,
            isDeletePending: false,
        };
    },
    methods: {
        editElement(onelog) {
            EventBus.emit('timeline:editAnnotation', onelog.objectid);
        },
        deleteElement(onelog) {
            this.isDeletePending = true;
            this.annotationService
                .deleteAnnotation(onelog.objectid)
                .then(() => {
                    this.deleteModal = false;
                    this.$nextTick(() => {
                        EventBus.emit('timeline:deleteLog', {
                            objectType: 'annotation',
                            objectId: onelog.objectid,
                        });
                    });
                })
                .finally(() => {
                    this.isDeletePending = false;
                });
        },
    },
};
</script>
